import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast';

const InterceptReqRes = () => {
  let authToken = localStorage.getItem('accessToken')
  const navigate = useNavigate()

  if (authToken) {
    axios.defaults.headers.common['accessToken'] = authToken;
  }

  axios.interceptors.request.use(
    (request) => {
      //console.log('Request',new Date(),request.url)
      return request
    }
  )

  axios.interceptors.response.use(
    (response) => {
      //console.log('Response',response)
      if (response?.data?.statusCode) {
        return response?.data?.responseData;
      }

      if (response?.data?.error?.errorCode === 17) {
        toast.error("Session Expired")
        return navigate('/logout')
      }
      //!D
      return response;
    },
    error => {
      //console.log('Error',error)
      if(error?.response?.status == 401){
        return navigate('/logout')
      }
    }
  )
}

export default InterceptReqRes
